<template>
  <div v-show="show" class="ff app-alert">
    <div class="app-alert-inner">
    <div class="app-alert-top"><span class="app-alert-title">{{title}}</span></div>
    <div class="app-alert-content" v-html="content"></div>
    <div class="app-alert-bottom">
      <div class="app-alert-reject" @click="reject">{{$bus.transify['COMMON_REJECT'] || 'COMMON_REJECT'}}</div>
      <div class="app-alert-accept" @click="confirm">{{$bus.transify['COMMON_ACCEPT'] || 'COMMON_ACCEPT'}}</div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    show: Boolean,
    title: String
  },
  data () {
    return {}
  },
  methods: {
    onUpdateShow (value) {
      this.$emit('update:show', value)
      if (!value) {
        // this.$audio.closeAudio.play()
      }
    },
    reject () {
      localStorage.setItem('policy_popup', 1)
      this.$bus.addGA('policyReject', true)
      this.onUpdateShow(false)
    },
    confirm () {
      localStorage.setItem('policy_popup', 1)
      this.$bus.addGA('policyAccept', true)
      this.onUpdateShow(false)
    }
  },
}
</script>

<style lang='scss'>
.ff.app-alert {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1200;
    background-color: rgba(0, 0, 0, 1);
  .app-alert-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    @include px2res(width, 876);
    @include px2res(height, 478);
    @include px2res(border-bottom, 4, 'solid', '#6f6f6f');
    background-color: #272727;
  }
  .app-alert-top {
    position: relative;
    width: 100%;
    @include px2res(height, 68);
    @include flexrc;
    @include px2res(font-size, 50);
    background-image: linear-gradient(to bottom, #b1b1b1, #f7f5ed);
    &::after {
      content: '';
      position: absolute;
      @include px2res(bottom, 1);
      width: 70%;
      @include px2res(height, 4);
      background: linear-gradient(
        to right,
        rgba(255, 242, 146, 0) 0%,
        rgba(255, 242, 146, 1) 20%,
        rgba(255, 242, 146, 1) 50%,
        rgba(255, 242, 146, 1) 80%,
        rgba(255, 242, 146, 0) 100%
      );
      filter: drop-shadow(0 .1em .05em rgba(228, 149, 18, .3))
    }
  }
  .app-alert-title {
    @include px2res(margin-top, 4);
    @include text-gradient(to bottom, #333332 10%, #836133);
  }
  .app-alert-content {
    @include px2res(width, 796);
    @include px2res(height, 268);
    @include px2res(font-size, 28);
    @include px2res(margin, 26, 'auto');
    @include px2res(padding, 5, 20);
    font-family: inherit !important;
    overflow: hidden;
    overflow-y: auto;
    background-color: #393939;
    * {
      font-family: inherit !important;
      @include px2res(line-height, initial,!important);
    }
    p {
      font-family: inherit !important;
      color: #fff;
    }
    &::-webkit-scrollbar:vertical {
      width: 0.5vw;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #8f8f8f
    }
    &::-webkit-scrollbar-track {
      background-color: #161616
    }
  }
  .app-alert-bottom {
    @include flexrc;
  }
  .app-alert-reject, .app-alert-accept {
    @include flexrc;
    @include px2res(width, 254);
    @include px2res(height, 62);
    @include px2res(padding-top, 5);
    @include px2res(margin, 0, 18);
    @include px2res(font-size, 36);
    @include px2res(border-radius, 4);
  }
  .app-alert-reject {
    filter: brightness(.9);
    color: #002757;
    background-image: linear-gradient(to bottom, #008dc1, #007297);
  }
  .app-alert-accept {
    color: #753f00;
    background-image: linear-gradient(to bottom, #fbed65, #f0b64d);
  }
}
@media screen and (orientation: portrait) and (max-width: 1080px) and (max-height: 1334px) {
  .app-alert-inner {
    max-width: 80%;
    // @include px2res(width, 876);
    // @include px2res(height, 478);
    .app-alert-content {
      max-width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/base/Alert.vue